import React, { PureComponent } from 'react'
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

import { showDeposit, changeMessageBoxState } from "../../actions/actionFunctions";
import CheckBox from '../common/checkBox';
import { getTotalPrice, getQuotePriceWithTaxes, toFixedPrice, getPriceWithCurrency } from '../../misc/helpers';

class DepositPopup extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      agreeChecked: false
    }
  }

  agreeAndContinue = () => {
    if (this.state.agreeChecked) {
      if (this.props.depositCallback) {
        this.props.depositCallback();
      }
      this.closeDepositPopup();
    }
  };

  closeDepositPopup = () => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    this.props.showDeposit(false);
    if (this.props.receiptUrl && !fabricatorSettings.hasPaymentGateway) {
      window.open(this.props.receiptUrl, "_blank");
    }
  };

  render() {
    if (!this.props.depositVisible) {
      return null;
    }
    const { intl } = this.props;
    const fabricatorSettings = this.props.fabricatorData.settings;
    const totalPrice = getTotalPrice();
    const grandTotal = getQuotePriceWithTaxes(totalPrice);
    let depositPerc = this.props.deposit || 10;
    let depositAmount = Math.floor((grandTotal * (depositPerc / 100)) * 100) / 100;
    return (
      <div className='cart-checkout-container'>
        <div className='cart-checkout-popup' onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <div className='cart-checkout-popup-header'>
            {/*<div className='cart-checkout-popup-header-icon'/>*/}
            <div className='cart-checkout-popup-header-text'><FormattedMessage id="depositPopup.title" /></div>
            <div className='ui-close cart-checkout-popup-header-close' onClick={this.closeDepositPopup} />
            <div className='cart-checkout-popup-header-total'>
              <div className='cart-checkout-popup-header-total-title'><FormattedMessage id="depositPopup.total" /></div>
              <div className='cart-checkout-popup-header-total-amount'>
                {getPriceWithCurrency(fabricatorSettings, toFixedPrice(grandTotal))}
              </div>
            </div>
          </div>
          <div className='cart-checkout-popup-body cart-checkout-popup-body--deposit'>
            {this.props.depositMessage || <div><FormattedMessage id="depositPopup.messagePart1" /> <span className="bold">{depositPerc}% <FormattedMessage id="depositPopup.messagePart2" /> </span>
              <FormattedMessage id="depositPopup.messagePart3" /> {depositPerc}% <FormattedMessage id="depositPopup.messagePart4" /></div>}

            <div className="cart-checkout-popup-deposit-amount">
              {depositPerc}% <FormattedMessage id="depositPopup.depositAmount" />
            </div>
            <div className="cart-checkout-popup-deposit-amount--amount">
              ${new Intl.NumberFormat(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(depositAmount)}
            </div>
            <CheckBox
              text={`${intl.formatMessage({ id: "depositPopup.confirmCheckboxText1" })} ${depositPerc}% ${intl.formatMessage({ id: "depositPopup.confirmCheckboxText2" })}`}
              checked={this.state.agreeChecked}
              onChecked={(checked) => this.setState({ agreeChecked: checked })} />
          </div>
          <div className={"cart-checkout-popup-footer" + (this.state.agreeChecked ? "" : " disabled")}>
            <button className="ui-button2 ui-button2--green" onClick={this.agreeAndContinue}>
              <span className="ui-button-continue"><FormattedMessage id="depositPopup.submitButton" /> &#9658;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { serverState, fabricatorState, cartState, printState } = state;
  return {
    jobId: serverState.jobId,
    deposit: fabricatorState.settings.deposit,
    depositMessage: fabricatorState.settings.depositMessage,
    depositVisible: cartState.depositVisible,
    depositCallback: cartState.depositCallback,
    fabricatorData: state.fabricatorState,
    receiptUrl: printState.receiptUrl,
  }
};

const mapDispatchToProps = {
  showDeposit,
  changeMessageBoxState
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DepositPopup)
)
